import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, message } from 'antd';
import { Link } from 'react-router-dom';
import { MyIcon, IMG_DEFAULT } from '../../common/baseConfig';
import LoginModal from "../common/LoginModal"
import * as actions from './redux/actions';
import { common } from '../../utils';

export class CoursePackStages extends Component {
  state = {
    visible: false
  };
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  getBuySum(data) {
    let sum = 0;
    data.forEach(element => {
      if (element.IsShow === 1) {
        sum += element.BuyBase + (element.BuyCount || 0);
      }

    });
    return sum;
  }
  getCourseCount(data) {
    let count = 0;
    data.forEach(element => {
      if (element.IsShow === 1) {
        count++;
      }
    });
    return count;
  }
  handleBuyNow(item) {
    let studentinfo = localStorage.getItem('studentinfo')
    if (studentinfo) { //已登录
      if (item.Ispay === 0) {
        this.props.actions
          .fetchGetIsOrder({ BusId: item.ID, BusType: 2 })
          .then(res => {
            if (res.SuccessResponse) {
              common.GetIsOrder(res.Data, this.props.history, '课程阶段', () => {
                //直接生成订单跳支付
                this.props.actions.fetchDirectOrder({
                  BusType: 2, // 0课程1 课程包 2 课程阶段
                  BusId: item.ID
                }).then(res => {
                  if (res.SuccessResponse) {
                    let params = {};
                    params.OrderId = res.Data.OrderId;
                    params.Money = res.Data.Price;
                    params.OrderName = "课程阶段支付";
                    params.IsStudent = 1;
                    this.props.actions.fetchUnifiedCreateOrder(params).then(res => {
                      if (res.SuccessResponse) {
                        this.props.history.push(`/paytype/${res.Data.OrderId}`);
                      }
                    })
                  }
                })
              });
            }
          });
      }
    } else { //未登录
      this.setState({ visible: true })
    }
  }
  onCancel() {
    this.setState({
      visible: false,
    })
  }
  render() {
    const { data } = this.props;
    const { fetchGetIsOrderPending } = this.props.course;
    const { visible } = this.state;
    if (!data) return null;
    return (
      <div className="course-course-pack-stages">
        {data.map(item => {
          if (item.Valid === 0) return null;
          return (
            <div className="course-course-pack-stage" key={item.ID}>
              <h1>{item.Name}</h1>
              <h2>{item.Description || '暂无介绍'}</h2>
              <div className="courses">
                {item.GetCourses.map(it => {
                  if (it.IsShow === 0) return null;
                  return (
                    <Link to={`/course/detail/${it.ID}`} target="_blank" key={it.ID} className="course">
                      <div className="content">
                        <img className="course-img" src={it.CoverPath ? it.CoverPath + '?x-oss-process=image/resize,m_fixed,h_158,w_283' : IMG_DEFAULT} alt="" />
                        <div className="course-detail">
                          <p className="course-detail-name">{it.Name}</p>
                          <p>
                            <span>¥{it.PreferentialPrice.toFixed(2)}</span>
                            <span>
                              <MyIcon type="iconrenshu" />
                              <b>{it.BuyBase + (it.BuyCount || 0)}</b>
                            </span>
                          </p>
                        </div>
                      </div>
                      <img className="symbol" src={require('../../images/symbol.png')} alt="" />
                    </Link>
                  )
                })}
              </div>
              {
                item.AllowStageSell === 1 && (
                  <div className="price-detail">
                    <div className="price">
                      <p>超值套餐价</p>
                      <p>
                        <strong>¥{item.PreferentialPrice.toFixed(2)}</strong>
                        <span>原价:</span>
                        <del>¥{item.Price.toFixed(2)}</del>
                      </p>
                      <p>
                        <strong>【全部课程】</strong>
                        <span>课程总数: {this.getCourseCount(item.GetCourses)}门课</span>
                        <span>|</span>
                        <span>购买人数: {this.getBuySum(item.GetCourses)}人</span>
                      </p>
                    </div>
                    <div className="btns">
                      <Button
                        type={item.Ispay === 2 ? 'yellow' : 'theme'}
                        className="goBuy"
                        disabled={item.Ispay === 1}
                        onClick={this.handleBuyNow.bind(this, item)}
                      >
                        {item.Ispay === 0 ? '立即购买' : item.Ispay === 1 ? '已购买' : '退款中'}
                      </Button>
                      {item.Ispay === 0 && (
                        <Button
                          type="theme3"
                          className="addCart addcartAnim"
                          id={`stage${item.ID}`}
                          loading={fetchGetIsOrderPending}
                          onClick={() => {
                            if (localStorage.getItem('studentinfo')) {  //已登录状态 加入购物车
                              if (item.Ispay === 0) {
                                this.props.actions
                                  .fetchGetIsOrder({ BusId: item.ID, BusType: 2 })
                                  .then(res => {
                                    if (res.SuccessResponse) {
                                      common.GetIsOrder(res.Data, this.props.history, '课程阶段', () => {
                                        //直接生成订单跳支付
                                        this.props.actions.fetchPutInCarts({
                                          Course_IDs: "2-" + item.ID
                                        }).then(res => {
                                          if (res.SuccessResponse) {
                                            this.props.actions.addCartCount();
                                          }
                                        })
                                        common.addCartAnim(() => { }, item.ID)
                                      }, true);
                                    }
                                  });
                              }
                            } else {//未登录状态加入购物车
                              let shoppingCartData = [], canAddShop = true;
                              if (localStorage.getItem('shoppingCartData')) {
                                shoppingCartData = JSON.parse(localStorage.getItem('shoppingCartData'));
                                shoppingCartData.forEach(ele => {
                                  if (ele.ID === item.ID) {
                                    canAddShop = false;
                                  }
                                })
                                if (!canAddShop) {
                                  message.warn('请勿重复添加购物车');
                                  return;
                                };
                                this.props.actions.fetchInputToCookies({
                                  model: shoppingCartData,
                                  newData: { BusId: item.ID, BusType: 2 }
                                }).then(_res => {
                                  if (_res.data.SuccessResponse) {
                                    if (_res.data.Data) {
                                      message.success('成功加入购物车');
                                      shoppingCartData.push({ ID: item.ID, BusType: 2, CoverPath: item.CoverPath, PreferentialPrice: item.PreferentialPrice, Name: item.Name });
                                      localStorage.setItem('shoppingCartData', JSON.stringify(shoppingCartData));
                                      this.props.actions.addCartCount();
                                    } else {
                                      message.warn(_res.data.Message);
                                    }
                                  }
                                })
                              } else {
                                message.success('成功加入购物车');
                                shoppingCartData.push({ ID: item.ID, BusType: 2, CoverPath: item.CoverPath, PreferentialPrice: item.PreferentialPrice, Name: item.Name });
                                localStorage.setItem('shoppingCartData', JSON.stringify(shoppingCartData));
                                this.props.actions.addCartCount();
                              }
                            }
                          }}
                        >
                          加入购物车
                        <img src={require("../../images/pack.png")} alt="" />
                        </Button>
                      )}
                    </div>
                  </div>
                )
              }
            </div>
          )
        })}
        <LoginModal visible={visible} onCancel={this.onCancel.bind(this)} />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CoursePackStages);



// WEBPACK FOOTER //
// ./src/features/course/CoursePackStages.js